import { render } from "./ArchivedTasks.vue?vue&type=template&id=197ab223&scoped=true"
import script from "./ArchivedTasks.vue?vue&type=script&lang=js"
export * from "./ArchivedTasks.vue?vue&type=script&lang=js"

import "./ArchivedTasks.vue?vue&type=style&index=0&id=197ab223&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-197ab223"

export default script